module.exports = __webpack_public_path__ + "059c6160170a15a665c1649b7dfbdb4f.pdf";